import { useMutation } from '@tanstack/react-query'

import { kickPlayer } from '../../services'

import type { KickPlayerResponse } from '@/modules/session/type'
import type {
	UseMutationOptions,
	UseMutationResult,
} from '@tanstack/react-query'

type UseMutationKickPlayerOptions = UseMutationOptions<
	KickPlayerResponse,
	Error,
	string
>

export default function useMutationKickPlayer(
	options?: UseMutationKickPlayerOptions,
): UseMutationResult<KickPlayerResponse, Error, string> {
	return useMutation({
		mutationFn: kickPlayer,
		...options,
	})
}
